import React, { Component } from 'react';
import './App.css';

import { Header } from './components/Header';
import { Footer } from './components/Footer';

// Routed Components
import { History } from "./components/History";
import { Top } from './components/Top/Top';
import { DirectorList } from './components/DirectorList';
import { Recruit } from "./components/Recruit";
import { Info } from "./components/Info";
import { VertPinPlage } from "./components/VertPinPlage";
import {Member} from "./components/Member";

import { Switch, Route } from 'react-router-dom';
import {Login} from "./components/Login";
import {Drawer} from "./components/Drawer";
import LightBox from "./components/LightBox";


class App extends Component {

  componentDidMount() {
    const header = document.getElementsByTagName('header')[0];
    window.onscroll = () => {
      const val = window.scrollY;
      if (val > 5) {
        header.classList.add('small-header')
      } else {
        header.classList.remove('small-header')
      }
    };
  }
  render() {
    return (
      <div className="App">
        <Drawer/>
        <div className="main-content">
          <Header/>
          <Switch>
            <Route path="/director" component={DirectorList}/>
            <Route path="/history" component={History}/>
            <Route path="/info/:page" component={Info}/>
            <Route path="/login" component={Login}/>
            <Route path="/member" component={Member}/>
            <Route path="/recruit" component={Recruit}/>
            <Route path="/vert-pin-plage" component={VertPinPlage}/>
            <Route path="/" component={Top}/>
          </Switch>
          <Footer/>
          <LightBox/>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js